import { baseSplitZodSchema } from "@redotech/redo-ab-testing-common/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateSplit = {
  name: "updateSplit" as const,
  input: z.object({
    splitId: zExt.objectId(),
    name: z.string().optional(),
    treatments: z.array(zExt.objectId()).optional(),
  }),
  output: z.object({ split: baseSplitZodSchema }),
};
